<script>
  import Container from "../shared/Container.svelte";
  import Select from "svelte-select";
  import Layout from "../Layout/Layout.svelte";
  import Modal from "../shared/Modal.svelte";
  import config from "../stores/config";
  import axios from "axios";
  import * as ls from "local-storage";
  import { Circle2 } from "svelte-loading-spinners";
  import TxCard from "../components/TxCard.svelte";
  import { onMount } from "svelte";
  import Loading from "../shared/Loading.svelte";
  import Empty from "../shared/Empty.svelte";

  // Adding A New Transaction (Tx) -------------------------------------------------------------------
  let newTx = {
    agent: "",
    amount: "",
    currency: null,
    reason: "",
    category: null,
  };

  const numberWithCommas = (x) => {
    return x?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  let showAddTxForm = false;
  let addTxLoading = false;

  const handleAddNewTx = async (e) => {
    for (const field in newTx) {
      if (!newTx[field]) {
        alert(`Veuillez remplir tous les champs!`);
        return;
      }
    }

    addTxLoading = true;

    let data = {
      ...newTx,
      category: newTx.category.value,
      currency: newTx.currency.value,
    };

    axios
      .post(`${$config.backendURL}/txs`, data, {
        headers: { authorization: ls.get("jwt") },
      })
      .then((res) => {
        showAddTxForm = false;
        addTxLoading = false;

        newTx = {
          agent: "",
          amount: "",
          currency: null,
          reason: "",
          category: null,
        };

        fetchTxs();
      })
      .catch((err) => {
        addTxLoading = false;
        console.log(err);
        alert(err);
      });
  };

  // Query For Txs ------------------------------------------------------------------------------

  let txs = null;
  let stats = null;
  let queryURL = "";
  let dateLabel;

  /* Query Parameters, just CHANGE them and the query will be regenerated as well, NO need to change everything */
  let page = 1;
  let searchkey = "";
  let ordered; // today|this-week|this-month|last-two-months|this-year nothing

  const fetchTxs = () => {
    txs = null;

    queryURL = `${$config.backendURL}/txs/page/${page}?`;
    queryURL += `&searchkey=${searchkey || ""}`;
    if (ordered) queryURL += `&ordered=${ordered || ""}`;

    axios
      .get(queryURL, { headers: { authorization: ls.get("jwt") } })
      .then((res) => {
        txs = res.data;
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(`${$config.backendURL}/txs/stats?ordered=${ordered}`, {
        headers: { authorization: ls.get("jwt") },
      })
      .then((res) => {
        stats = res.data;
        console.log(stats);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handlePrevPage = () => {
    if (page <= 1) page = 1;
    else {
      page = page - 1;
      fetchTxs();
    }
  };
  const handleNextPage = () => {
    if (page <= 0) page = 0;
    page = page + 1;
    fetchTxs();
  };

  const handleRefresh = () => {
    page = 1;
    searchkey = null;
    ordered = null;
    dateLabel = "";
    fetchTxs();
  };

  onMount(() => {
    fetchTxs();
  });
</script>

<svelte:head>
  <title>SAMAKI EXPRESS | Toutes les transactions</title>
</svelte:head>

<Layout>
  <Modal
    show={showAddTxForm}
    on:modalClose={() => {
      showAddTxForm = false;
    }}
  >
    <div class="grid gap-y-2">
      <input
        bind:value={newTx.agent}
        type="text"
        placeholder="Agent/Companie"
        required
      />

      <Select
        items={["ENTREE", "SORTIE"]}
        bind:selectedValue={newTx.category}
        placeholder="Entrée ou Sortie"
      />

      <input bind:value={newTx.amount} type="number" placeholder="Montant" />

      <Select
        items={["DOLLARS", "FRANCS"]}
        bind:selectedValue={newTx.currency}
        placeholder="Devise"
      />

      <input
        bind:value={newTx.reason}
        type="text"
        placeholder="Raison"
        required
      />

      {#if addTxLoading}
        <div class="grid grid-cols-1 gap-8">
          <div class="btn btn-primary">
            <Circle2
              size="25"
              unit="px"
              colorOuter="#F4A261"
              colorCenter="#40B3FF"
              colorInner="#676778"
            />
            <span class="ml-4">Veuillez Patienter...</span>
          </div>
        </div>
      {:else}
        <!-- else content here -->
        <div class="flex">
          <button
            style="width: 100%;"
            class="btn btn-primary"
            on:click={handleAddNewTx}
          >
            <ion-icon name="checkmark-circle" class="text-2xl mr-3" />
            Sauver
          </button>
          <button
            style="width: 100%;"
            class="ml-4 btn btn-secondary"
            on:click={(e) => (showAddTxForm = false)}
          >
            <ion-icon name="close-circle" class="text-2xl mr-3" />
            Fermer
          </button>
        </div>
      {/if}
    </div>
  </Modal>

  <div class="py-7" />

  <Container>
    {#if stats}
      <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
        <!--  -->
        <div class="flex justify-center col-span-full">
          <input
            bind:value={searchkey}
            on:input={fetchTxs}
            class="shadow-sm"
            type="text"
            placeholder="Rechercher par agent, companie, raison..."
          />
          <button class="ml-2 btn btn-blue" on:click={fetchTxs}>
            <ion-icon name="search-circle" class="text-2xl" />
          </button>
        </div>
        <!--  -->
        <div
          class="uppercase border border-blue-200 text-lg text-gray-500 rounded-md shadow-sm flex items-center bg-white stat-card py-2 px-5"
        >
          <div
            class="bg-blue-400 tracking-wider uppercase mr-2 text-xs py-1 px-2 rounded-md shadow-sm text-gray-100"
          >
            Période
          </div>
          {dateLabel || "Toutes"}
        </div>
        <div
          class="uppercase border border-green-200 text-lg text-gray-500 rounded-md shadow-sm flex items-center bg-white stat-card py-2 px-5"
        >
          <div
            class="bg-green-400 tracking-wider uppercase mr-2 text-xs py-1 px-2 rounded-md shadow-sm text-gray-100"
          >
            total entrées
          </div>
          <!-- {numberWithCommas(stats.ENTREE) || "0"} USD -->
          <!-- <div class="text-blue-400 mx-2">→</div> -->
          {numberWithCommas(stats.ENTREE * 2000)} FC
        </div>
        <div
          class="uppercase border border-red-200 text-lg text-gray-500 rounded-md shadow-sm flex items-center bg-white stat-card py-2 px-5"
        >
          <div
            class="bg-red-400 tracking-wider uppercase mr-2 text-xs py-1 px-2 rounded-md shadow-sm text-gray-100"
          >
            total sorties
          </div>
          <!-- {numberWithCommas(stats.SORTIE) || "0"} USD -->
          <!-- <div class="text-blue-400 mx-2">→</div> -->
          {numberWithCommas(stats.SORTIE * 2000)} FC
        </div>
      </div>
    {/if}
  </Container>

  <Container>
    <div class="mt-2 grid grid-cols-1 md:grid-cols-3 gap-2">
      <!--  -->
      <div class="flex items-center">
        <div class="w-full shadow-sm rounded-sm">
          <Select
            items={[
              { label: "Aujourd'hui", value: "today" },
              {
                label: "Cette Semaine",
                value: "this-week",
              },
              {
                label: "Ce Mois",
                value: "this-month",
              },
              {
                label: "2 Derniers Mois",
                value: "last-two-months",
              },
              {
                label: "Cette Année",
                value: "this-year",
              },
              {
                label: "Depuis Jour 1",
                value: "all",
              },
            ]}
            selectedValue={ordered}
            on:select={(e) => {
              if (e.detail.value == "all") {
                ordered = null;
                dateLabel = "";
              } else {
                ordered = e.detail.value;
                dateLabel = `${e.detail.label}`;
              }
              fetchTxs();
            }}
            placeholder="Selectionner une période"
          />
        </div>
      </div>
      <!--  -->
      <button
        class="btn btn-blue"
        on:click={(e) => {
          showAddTxForm = true;
        }}
        style="width: 100%;"
      >
        <ion-icon name="add-circle" class="text-2xl mr-3" />
        Ajouter une transaction
      </button>
      <!--  -->
      <button
        class="btn btn-secondary"
        on:click={handleRefresh}
        style="width: 100%;"
      >
        Actualiser
        <ion-icon name="refresh-circle" class="text-2xl ml-3" />
      </button>
      <!--  -->
    </div>
  </Container>

  <Container>
    {#if txs == null}
      <Loading text="Chargement..." />
    {:else}
      <div class="my-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
        {#each txs as tx (tx._id)}
          <div class="">
            <TxCard
              {...tx}
              on:delete={() => {
                page = 1;
                searchkey = "";
                fetchTxs();
              }}
              on:update={() => {
                page = 1;
                searchkey = "";
                fetchTxs();
              }}
            />
          </div>
        {:else}
          <div class="col-span-full">
            <Empty />
          </div>
        {/each}
      </div>

      <div class="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-2">
        <button
          class="btn btn-secondary"
          style="width: 100%;"
          on:click={() => {
            handlePrevPage();
          }}
        >
          <ion-icon name="arrow-back-circle" class="text-2xl mr-2" />
          Page Prec.
        </button>
        <button
          class="btn btn-secondary"
          style="width: 100%;"
          on:click={() => {
            handleNextPage();
          }}
        >
          Page Suiv.
          <ion-icon name="arrow-forward-circle" class="text-2xl ml-2" />
        </button>
      </div>
    {/if}
  </Container>
</Layout>

<style>
  .stat-card {
    background-image: url("data:image/svg+xml,%3Csvg width='84' height='48' viewBox='0 0 84 48' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h12v6H0V0zm28 8h12v6H28V8zm14-8h12v6H42V0zm14 0h12v6H56V0zm0 8h12v6H56V8zM42 8h12v6H42V8zm0 16h12v6H42v-6zm14-8h12v6H56v-6zm14 0h12v6H70v-6zm0-16h12v6H70V0zM28 32h12v6H28v-6zM14 16h12v6H14v-6zM0 24h12v6H0v-6zm0 8h12v6H0v-6zm14 0h12v6H14v-6zm14 8h12v6H28v-6zm-14 0h12v6H14v-6zm28 0h12v6H42v-6zm14-8h12v6H56v-6zm0-8h12v6H56v-6zm14 8h12v6H70v-6zm0 8h12v6H70v-6zM14 24h12v6H14v-6zm14-8h12v6H28v-6zM14 8h12v6H14V8zM0 8h12v6H0V8z' fill='%23000000' fill-opacity='0.02' fill-rule='evenodd'/%3E%3C/svg%3E");
  }
</style>
